<template>
  <b-card class="rounded-lg">
    <report-header
      :title="$t('ledger_rep_centers')"
      :scope-label="scopeLabel"
      :can-company="canCompany"
      :company="company"
      @company="company = $event; load()"
      @print="printReport"
    />
    <div class="d-flex flex-wrap mb-1">
      <b-form-input v-model="from" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-form-input v-model="to" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-button size="sm" variant="primary" @click="load">{{ $t('ledger_assets_load') }}</b-button>
    </div>
    <div v-if="loading" class="text-center py-3"><b-spinner /></div>
    <b-row v-else-if="report">
      <b-col
        v-for="center in report.centers || []"
        :key="center.key"
        cols="12"
        md="6"
        class="mb-1"
      >
        <b-card class="h-100">
          <h5>{{ center.label_ar || center.label }}</h5>
          <div class="ledger-num">
            {{ $t('ledger_cost_revenue') }} {{ money(center.revenue) }}
          </div>
          <div class="ledger-num">
            {{ $t('ledger_cost_actual') }} {{ money(center.direct_cost) }}
          </div>
          <div class="ledger-num">
            {{ $t('ledger_cost_profit') }} {{ money(center.gross_profit) }} ({{ center.margin_percent }}%)
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BButton, BSpinner } from 'bootstrap-vue'
import { getProfitability } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'

export default {
  name: 'ProfitabilityReport',
  components: { BCard, BRow, BCol, BFormInput, BButton, BSpinner, ReportHeader },
  mixins: [reportMixin],
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getProfitability({ from: this.from, to: this.to, ...this.scopeParams })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 11rem; }
.ledger-center-pending { background: #f3f3f3; color: #6e6b7b; }
</style>
